$ = require 'jquery'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
BoardMemberAddMultipleView = require 'views/board-menu/board-member-add-multiple-view'
trackUe = require 'debug/trackUe'

module.exports = class ConfirmationPublicBoardsView extends View
  viewTitleKey: 'change to public'

  className: 'confirmation-popover'

  events:
    'click .js-submit': 'selectVis'
    'click .js-action-link': 'renderInvitationLink'

    'mouseenter .js-action-link': 'mouseenter'
    'mouseleave .js-action-link': 'mouseleave'

  render: ->
    data = @model.toJSON()

    @$el.html(
      templates.fill(
        'popover_confirmation_public_boards',
        data
      )
    )
    @

  selectVis: (e) ->
    Util.stop(e)

    change = if @model.getPref('permissionLevel') != 'public' then 1 else 0

    @model.setPref('permissionLevel', 'public')
    @model.save()

    trackUe('board', 'sets', 'board visibility', '', 'to public', '', { boardid: @model.id, change: change })

    PopOver.hide()

  renderInvitationLink: (e) ->
    Util.stop(e)
    view = new BoardMemberAddMultipleView({ @model, @modelCache })
    view.loadOrgData()
    $('.js-open-manage-board-members').removeClass('open-manage-boards-offset')

    PopOver.toggle
      elem: $('.js-open-manage-board-members')
      view: view
      trackUe('Invitation Link', 'opens', 'Multiple members invite view', '', '', 'by clicking invite link in confirmation view', { boardid: @model.id })

    return

  mouseenter: (e) ->
    $('.js-open-manage-board-members').addClass('open-manage-boards-offset')

  mouseleave: (e) ->
    @setTimeout ->
      $('.js-open-manage-board-members').removeClass('open-manage-boards-offset')
    , 0


// WEBPACK FOOTER //
// ./app/scripts/views/board/confirmation-public-boards-view.coffee